<template>
  <div class="outDrawer">
    <el-drawer
        title="AI广告助手"
        :visible.sync="visible"
        direction="rtl"
        size="80%"
        custom-class="aiOutDrawer"
        :before-close="handleClose">
      <div class="drawerBody">
        <home-page v-if="aiCurrentPage===1"></home-page>
        <second-page v-if="aiCurrentPage===2"></second-page>
        <third-page v-if="aiCurrentPage===3"></third-page>
      </div>
      <div slot="title" class="drawerTitle">
        <el-link v-show="aiCurrentPage!==1" icon="el-icon-back" :underline="false" @click="goBack"></el-link>
        <img src="@/assets/aiads.png" alt=""/>
        <div class="title-container">
          <div class="title">AI广告助手</div>
          <div class="info">帮你快速撰写关键词、广告标题、广告说明</div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import {mapState, mapMutations} from "vuex";
import homePage from "@/components/aiAds/homePage.vue";
import secondPage from "@/components/aiAds/secondPage.vue";
import thirdPage from "@/components/aiAds/thirdPage.vue";


export default {
  name: 'outDrawer',
  components: {
    homePage,
    secondPage,
    thirdPage
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      visible: state => state.aiAds.showDrawer,
      aiCurrentPage: state => state.aiAds.aiCurrentPage
    }),
  },
  methods: {
    ...mapMutations(['setShowDrawer', 'setCurrentPage']),
    // 返回
    goBack() {
      if (this.aiCurrentPage !== 1) {
        this.setCurrentPage(this.aiCurrentPage - 1)
      }
    },
    handleClose() {
      this.$confirm('确认关闭？')
          .then(() => {
            this.setShowDrawer()
          })
          .catch(() => {
          });
    }
  }
}
</script>
<style lang="scss">
.el-drawer__body {
  overflow-y: auto;
}

.aiOutDrawer {
  .drawerTitle {
    display: flex;
    align-items: center;

    i {
      font-size: 30px;
      margin-right: 20px;
    }

    img {

      width: 40px;
      height: 40px;
      margin-right: 10px;
    }

    .title-container {
      .title {
        font-size: 18px;
        color: #333;
      }

      .info {
        font-size: 12px;
        margin-top: 5px;
      }
    }
  }

  .drawerBody {
    box-sizing: border-box;
    padding: 0 50px 100px;
  }
}
</style>